import { render, staticRenderFns } from "./SetLanguageModal.vue?vue&type=template&id=a0b074f8&scoped=true&"
import script from "./SetLanguageModal.vue?vue&type=script&lang=js&"
export * from "./SetLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./SetLanguageModal.vue?vue&type=style&index=0&id=a0b074f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b074f8",
  null
  
)

export default component.exports